"use client";

import { useEffect, useState } from "react";
import axios from "axios";
import Link from "next/link";
import Image from "next/image";
import { GoldHeading } from "@/components/ui/gold-heading";
import { GlassCard } from "@/components/ui/glass-card";

interface Blog {
  blog_id: number;
  title: string;
  subheading: string;
  thumbnail: string;
  coverImg: string;
  bodyImg: string;
  published_date: string;
}

export default function BlogPage() {
  const [blogs, setBlogs] = useState<Blog[]>([]);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const res = await axios.post("http://localhost:9000/api/blogs/all", {});
        setBlogs(res.data.blogs);
      } catch (err) {
        console.error("Error fetching blogs:", err);
      }
    };

    fetchBlogs();
  }, []);

  const getImageUrl = (thumbnail: string) => {
    if (thumbnail.startsWith("http")) return thumbnail;
    return `http://localhost:9000/uploads/blogs/${thumbnail}`;
  };

  return (
    <div className="container mx-auto py-24">
      <div className="space-y-20">
        {/* Hero Section */}
        <section className="text-center space-y-6 max-w-3xl mx-auto">
          <GoldHeading>Latest Updates</GoldHeading>
          <h1 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-[#d4af37] from-20% via-white via-30% to-[#d4af37] to-90% bg-clip-text text-transparent">
            Insights, Inspiration & Ideas
          </h1>
          <p className="text-lg text-muted-foreground">
            Stay inspired with the latest trends, ideas, and insights from the world of interior design.
          </p>
        </section>

        {/* Blog Cards */}
        <section className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {blogs.map((blog) => (
            <Link key={blog.blog_id} href={`/blog/${blog.blog_id}`}>
              <GlassCard className="p-0 overflow-hidden hover:shadow-2xl transition duration-300 group">
                <div className="relative h-48 w-full">
                  <Image
                    src={getImageUrl(blog.thumbnail)}
                    alt={blog.title}
                    fill
                    className="object-cover group-hover:scale-105 transition-transform duration-300 rounded-t-xl"
                  />
                </div>
                <div className="p-5 space-y-2">
                  <h2 className="text-xl font-semibold">{blog.title}</h2>
                  <p className="text-sm text-muted-foreground">{blog.subheading}</p>
                  <p className="text-xs text-gray-400">
                    {new Date(blog.published_date).toDateString()}
                  </p>
                </div>
              </GlassCard>
            </Link>
          ))}
        </section>
      </div>
    </div>
  );
}
